export const notificationTypes = Object.freeze({
	ExportFile: 1,
	ExportFileFailed: 2,
	ImportFile: 3,
	ImportFileFailed: 4,
});
